module.exports = __webpack_public_path__ + "img/mesa_hl30.f12b2cfe.png";